import { render, staticRenderFns } from "./ProductTeaser.vue?vue&type=template&id=5770d5ee"
import script from "./ProductTeaser.vue?vue&type=script&lang=js"
export * from "./ProductTeaser.vue?vue&type=script&lang=js"
import style0 from "./ProductTeaser.vue?vue&type=style&index=0&id=5770d5ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports